// imports
import * as $ from 'jquery';

let bookmarks;

(window as any).unloadEducations = unloadEducations;

export function initialize(): void {
    $('.js-load-educations').on('click', onShowEducations);
};

function unloadEducations(): void {
    bookmarks = null;
}

function onShowEducations(event: any, params: any): void {
    $('.sidebar').addClass('sidebar--sub-level');
    $(".subNavigation").addClass("selected--bookmarks");
    $(".pIEducations").addClass("selectedItem");

    $("#myfavorites_sidebar").addClass("selectedItem").focus();

    $("#js-react-bookmarks-expanded .coverages__tabs-container .coverages__tab:last-child").click().focus();

    $(".pIUser").hide();
    $(".pIRecentlyRead").hide();
    $(".pINotes").hide();
    $(".pIWatched").hide();

    $("#mynotes_sidebar").removeClass("selectedItem");
    $("#mylatestvisited_sidebar").removeClass("selectedItem");
    $("#mycoverage_sidebar").removeClass("selectedItem");

}
